import { accountActivityUrl } from 'syf-api/api/endpoints';
import useFetch from 'syf-api/api/useFetch';
export var defaultActivityData = {
    pageMetaData: {
        nextCursor: ''
    },
    activity: { items: {}, itemsIds: [] }
};
export var activityQuery = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType, config = _a.config, filterByValue = _a.filterByValue, nextCursor = _a.nextCursor;
    return function () {
        var fetchWrapper = useFetch(config);
        var params = new URLSearchParams({
            'cipher.accountId': accountId
        });
        if (accountIdType) {
            params.set('accountIdType', accountIdType);
        }
        if (filterByValue === null || filterByValue === void 0 ? void 0 : filterByValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
            params.set('statementDate', filterByValue);
        }
        if (filterByValue === 'recent') {
            params.set('transactionCycleType', filterByValue);
        }
        if (nextCursor) {
            params.set('cursor', nextCursor);
        }
        return fetchWrapper("".concat(accountActivityUrl, "?").concat(params), {
            method: 'GET'
        });
    };
};
//# sourceMappingURL=activity-query.js.map